import { Modal, Tag, Avatar, Image, Empty, Timeline } from "antd";
import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import type { ComponentRow, HistoryRecord, WorkTask } from "./data";

function StatusTag({ status }: { status: HistoryRecord["status"] }) {
  return status === "success" ? (
    <Tag icon={<CheckCircleFilled />} color="success">
      完成
    </Tag>
  ) : (
    <Tag icon={<CloseCircleFilled />} color="error">
      錯誤
    </Tag>
  );
}

export default function HistoryModal({
  open,
  row,
  task,
  workLabel,
  onClose,
}: {
  open: boolean;
  row: ComponentRow | null;
  task: WorkTask | null;
  workLabel: string;
  onClose: () => void;
}) {
  return (
    <Modal
      title={
        row
          ? `回報紀錄 — ${row.componentNo}（廣達ID ${row.qdId}）｜${workLabel}`
          : "回報紀錄"
      }
      open={open}
      onCancel={onClose}
      footer={null}
      width={640}
    >
      {!task || task.history.length === 0 ? (
        <Empty description="尚無回報紀錄" />
      ) : (
        <Timeline
          style={{ marginTop: 16 }}
          items={task.history.map((rec) => ({
            color: rec.revoked
              ? "gray"
              : rec.status === "success"
                ? "green"
                : "red",
            children: (
              <div
                style={{
                  border: "1px solid #f0f0f0",
                  borderRadius: 8,
                  padding: 12,
                  marginBottom: 4,
                  opacity: rec.revoked ? 0.6 : 1,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom: 8,
                  }}
                >
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 8 }}
                  >
                    <Avatar size={36} src={rec.personPhoto}>
                      {rec.personName.slice(0, 1)}
                    </Avatar>
                    <div>
                      <div style={{ fontWeight: 600 }}>{rec.personName}</div>
                      <div style={{ fontSize: 12, color: "#8c8c8c" }}>
                        {rec.reportedAt}
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    {rec.revoked && <Tag color="default">已取消</Tag>}
                    <StatusTag status={rec.status} />
                  </div>
                </div>

                {rec.description && (
                  <p style={{ margin: "0 0 8px", color: "#595959" }}>
                    {rec.description}
                  </p>
                )}

                {rec.photo && (
                  <Image
                    src={rec.photo}
                    alt="現場照片"
                    width={180}
                    height={120}
                    style={{ objectFit: "cover", borderRadius: 6 }}
                    fallback="/placeholder.svg"
                  />
                )}
              </div>
            ),
          }))}
        />
      )}
    </Modal>
  );
}
